import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEHistoryOverviewCardActions = {
  initPeHistoryOverviewCard: ({ commit }) => {
    commit('setPeHistoryOverviewCardLock', true)
  },
  peHistoryOverviewCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        years_education: section.years_education,
        any_work_history: section.any_work_history,
        any_criminal_history: section.any_criminal_history,
        previously_detained: section.previously_detained,
        presently_detained: section.presently_detained,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeHistoryOverviewCardLock', true)
        commit('pePatchParty', {
          years_education: updatedParty.years_education,
          any_work_history: updatedParty.any_work_history,
          any_criminal_history: updatedParty.any_criminal_history,
          previously_detained: updatedParty.previously_detained,
          presently_detained: updatedParty.presently_detained,
        })
      }).
      catch(handleError)
  },
}

export const PEHistoryOverviewCardMutations = {
  setPeHistoryOverviewCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'HistoryOverviewCard', lock)
  },
}

export const PEHistoryOverviewCardGetters = {
  peHistoryOverviewCardLock: state => state.partyEdit.partySections.HistoryOverviewCard,
}
